import { useState } from "react";
import DialogModal from "src/components/Dialog";
import { Gift } from "src/types/api";
import HistoryDetails from "../modals/HistoryDetails";

interface Props {
  item: Gift;
}

const PaymentHistoryItem = ({ item }: Props) => {
  const [isHistoryDetailsOpen, setIsHistoryDetailsOpen] = useState(false);

  return (
    <>
      <div
        className="flex h-14 items-center justify-between gap-4 border-b px-4 text-sm transition duration-500 hover:bg-gray-100 sm:px-8"
        role="listitem" // Added ARIA role for accessibility
        onClick={() => {
          setIsHistoryDetailsOpen(true);
        }}
      >
        <span
          className=""
          dangerouslySetInnerHTML={{ __html: item.narration }}
        />
        {/* <span className={`font-bold ${"text-green-500"}`}>
          {`${getSymbolFromCurrency("ngn")}${formatMoney(item.amount).toLocaleString()}`}
        </span> */}
      </div>
      <DialogModal
        open={isHistoryDetailsOpen}
        onOpenChange={setIsHistoryDetailsOpen}
        asChild
      >
        <HistoryDetails item={item} />
      </DialogModal>
    </>
  );
};

export default PaymentHistoryItem;
